import {
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export const Banner = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const handleBannerClick = () => {
    navigate('/home');
  };

  return (
    <Card sx={{ width: "100%", maxWidth: "none" }}>
      <CardActionArea onClick={handleBannerClick}>
        <CardMedia
          component="img"
          height={isMobile ? "200" : isTablet ? "250" : "300"}
          image="/images/banner.png"
          alt="banner image"
          sx={{
            objectFit: 'cover',
            width: '100%'
          }}
        />
      </CardActionArea>
    </Card>
  );
};
